import { Component, OnInit } from '@angular/core';
// import { Router } from '@angular/router';
import { AppStateService } from '../../../services/appState.service';

@Component({
  selector: 'app-IOSLinkDocumentation',
  templateUrl: './IOSLinkDocumentation.component.html',
  styleUrls: ['./IOSLinkDocumentation.component.css']
})
export class IOSLinkDocumentationComponent implements OnInit {

  constructor(
    // private router: Router,
    private appStateService: AppStateService) { }

  ngOnInit() {
    this.appStateService.appStatusSetzen({ aktuellerMenuePunkt: 'IOSLinkDocumentation' });
  }

}
